import { render } from "./CompanyAutosuggest.vue?vue&type=template&id=32989379"
import script from "./CompanyAutosuggest.vue?vue&type=script&lang=js"
export * from "./CompanyAutosuggest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__